export const WAEC_PHYSICS = [
  {
    q: "What is the SI unit of force?",
    o: ["Joule", "Watt", "Newton", "Pascal"],
    a: 2,
    e: "Force is measured in Newtons (N). F = ma (mass × acceleration).",
    h: "Named after Isaac Newton.",
    yr: "2023",
  },
  {
    q: "Which type of wave requires a medium to travel?",
    o: ["Electromagnetic", "Light", "Mechanical", "Radio"],
    a: 2,
    e: "Mechanical waves (e.g. sound) need a medium. Electromagnetic waves can travel through a vacuum.",
    h: "Sound cannot travel in space.",
    yr: "2022",
  },
  {
    q: "The formula for kinetic energy is:",
    o: ["mgh", "½mv²", "mv", "F×d"],
    a: 1,
    e: "KE = ½mv², where m = mass and v = velocity.",
    h: "Half, mass, velocity squared.",
    yr: "2023",
  },
  {
    q: "Ohm's Law states that V =",
    o: ["I/R", "IR", "I²R", "I+R"],
    a: 1,
    e: "V = IR. Voltage equals current multiplied by resistance.",
    h: "Voltage = Current × Resistance.",
    yr: "2021",
  },
  {
    q: "What happens to the resistance of a metallic conductor when temperature increases?",
    o: ["Decreases", "Stays same", "Increases", "Becomes zero"],
    a: 2,
    e: "For metals, resistance increases with temperature because atoms vibrate more, impeding electron flow.",
    h: "More heat = more atomic vibration.",
    yr: "2022",
  },
];

export const WAEC_PHYSICS_LEARN = [
  {
    topic: "Motion & Kinematics",
    content: "The equations of motion (SUVAT): v = u + at; s = ut + ½at²; v² = u² + 2as; s = ½(u+v)t. Where s = displacement, u = initial velocity, v = final velocity, a = acceleration, t = time. Velocity is speed with direction (vector); speed is scalar.",
  },
  {
    topic: "Newton's Laws of Motion",
    content: "1st Law (Inertia): A body remains at rest or uniform motion unless acted upon by an external force. 2nd Law: F = ma. 3rd Law: For every action there is an equal and opposite reaction. Weight = mg where g ≈ 10 m/s² (or 9.8 m/s²).",
  },
  {
    topic: "Electricity",
    content: "Ohm's Law: V = IR. Series circuit: Rtotal = R1 + R2 + R3. Parallel circuit: 1/Rtotal = 1/R1 + 1/R2. Power: P = IV = I²R = V²/R. Energy: E = Pt. Current flows from positive to negative terminal externally.",
  },
  {
    topic: "Waves",
    content: "Wave speed v = fλ (frequency × wavelength). Transverse waves: oscillation perpendicular to direction (light, water). Longitudinal waves: oscillation parallel to direction (sound). Reflection, refraction, diffraction, and interference are wave properties.",
  },
  {
    topic: "Heat & Thermodynamics",
    content: "Heat flows from hot to cold. Methods of heat transfer: Conduction (solids), Convection (fluids), Radiation (no medium needed). Specific heat capacity c: Q = mcΔT. Latent heat: energy absorbed/released during change of state without temperature change.",
  },
];
